import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ScholarshipType } from "../../types/Scholarship";
import { get, post, put } from "../../utils/axios-config";
import { SCHOLARSHIPS } from "../../utils/constants";

export const createScholarship = async (data: ScholarshipType) =>
    await post(SCHOLARSHIPS, data);

export const getScholarships = async (data: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
    });

    if (data?.IdStudent) {
        queryParams.append('idStudent', data.IdStudent);
    }
    
    return await get<PagedResultsType<ScholarshipType>>(`${SCHOLARSHIPS}?${queryParams.toString()}`);
};

export const updateScholarship = async (data: ScholarshipType) =>
    await put(SCHOLARSHIPS, data);


